import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Spinner } from '@stone-payments/jade';
import { DigitalWalletSelectionOption } from '../../app/components/digitalWallets/digitalWalletSelection.component';
import { digitalWallets } from '../../app/types/digitalWallets.types';
import { usePageSharedData } from '../../hooks/usePageSharedData';
import { GooglePayLogoIllustration } from './googlePayLogo.component';

type GooglePayProps = {
  setIsDigitalWalletsSelected: (digitalWallet: digitalWallets) => void;
  active?: boolean;
};

export const GooglePay = ({
  setIsDigitalWalletsSelected,
  active,
}: GooglePayProps) => {
  const { paymentLinkIdData } = usePageSharedData();
  const { isCustomerFormLoading } = usePaymentMethod();

  if (paymentLinkIdData.isLoading)
    return <Spinner size="medium" color="brand" />;
  if (!paymentLinkIdData?.data?.payment_settings.google_pay_enabled)
    return null;

  return (
    <DigitalWalletSelectionOption
      onClick={() => setIsDigitalWalletsSelected('googlePay')}
      active={active}
      disabled={isCustomerFormLoading}
    >
      <GooglePayLogoIllustration />
    </DigitalWalletSelectionOption>
  );
};
